import { GET_ADJUSTMENT_SCHEMA_PARAMS } from '../actions';

const initialState = {};

const adjustmentsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ADJUSTMENT_SCHEMA_PARAMS:
      return payload || initialState;

    default:
      return state;
  }
};

export default adjustmentsSchemaReducer;
